import React from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import { useNavigate } from "react-router-dom";
import Pits from "./Pits";

function UpdatePit() {
  const navigation = useNavigate();

  return (
    <AppContainer title="Installation Details">
      <div className="card custom-card main-content-body-profile">
        <div className="card-body tab-content h-100">
          <h4 className="card-title">Update pole Pit</h4>

          <Pits navi={navigation} />
        </div>
      </div>
    </AppContainer>
  );
}

export default UpdatePit;
